import React, { useState, useEffect } from 'react'
import { useLocation } from '@reach/router'

import { FloatingNavigation } from './modules/floatingNavigation'
import { ScrollSpyNav } from './modules/scrollSpyNav'
import { MiniMediaSlider } from './modules/miniMediaSlider'
import { Layers } from './modules/layers'
import { TextVideoBlock } from './modules/textVideoBlock'

export const getLanguage = () => {
    if (typeof window !== 'undefined') {
        const path = window.location.pathname;
        if (path.includes('/spanish')) return 'sp';
        if (path.includes('/portuguese')) return 'pt';
    }
    return 'en';
};

export const FarmersAndProducers = ({ sectionVisibility }) => {
    const [scrolling, setScrolling] = useState(false)
    const location = useLocation()
    const locPathname = location.pathname
    const languageList = [
        { abbrv: 'en', name: 'English', link: '/hermetica/' },
        { abbrv: 'sp', name: 'Spanish', link: '/hermetica/spanish/' },
        { abbrv: 'pt', name: 'Portuguese', link: '/hermetica/portuguese/'}
    ]

    const handleScroll = () => {
        if(window.scrollY > 0) {
            setScrolling(true)
        } else {
            setScrolling(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    if(sectionVisibility) {
        return (
            <div className='relative block pt-170 bg-cloud-gray'>
                <div className="relative grid col-1-6-1 col-1-md gap-40 bg-cloud-gray">
                    <FloatingNavigation 
                        scrolling={scrolling} 
                        contentSectionOne={'hermetica'}
                        contentSectionTwo={'specSheet'}
                        contentSectionThree={'textVideoBlock'}
                    />
                    <MiniMediaSlider/>
                    <ScrollSpyNav 
                        scrolling={scrolling} 
                        locPathname={locPathname} 
                        languageList={languageList} 
                    />
                </div>
                <div className='relative grid col-1-6-1 col-1-md gap-40 bg-code-bg-secondary'>
                    <div className='block'></div>
                    <div className='block'>
                        <Layers/>
                        <TextVideoBlock/>
                    </div>
                    <div className='block'></div>
                </div>
            </div>
        )
    } else return null
}